module.exports = "/_next/static/images/Hero-0dda9ec4b37c7da0b3399c915b1e76e8.webp";